import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "breadcrumbs-container" }
const _hoisted_2 = {
  key: 1,
  class: "text"
}


import { TranslateResult } from "vue-i18n";

interface Props {
  items: Array<{
    label: string | TranslateResult;
    route: string;
  }>;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VBreadcrumbs',
  props: {
    items: { default: () => [
    {
      label: "Campaigns",
      route: "",
    },
  ] }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.items, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "breadcrumb"
      }, [
        (item.route)
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              to: { name: item.route },
              class: "link"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(item.label), 1)
              ], undefined, true),
              _: 2
            }, 1032, ["to"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(item.label), 1))
      ]))
    }), 128))
  ]))
}
}

})